import { IconLetterCase, IconLetterCaseUpper } from '@tabler/icons-react';
import { memo } from 'react';
import { classnames } from '@/libs/utils';
import TooltipV2 from '@/components/TooltipV2';

interface Props {
  value: boolean;
  onChange: (value: boolean) => void;
  tooltipId?: string;
}

const SpeakerLabelUppercaseToggle = memo(({ value, onChange, tooltipId = 'uppercase-toggle-tooltip' }: Props) => (
  <TooltipV2
    tooltipId={tooltipId}
    tooltipElement={
      <button
        data-testid="uppercase-toggle"
        aria-label="Toggle uppercase text"
        aria-pressed={value}
        className={classnames(
          'flex size-8 flex-row items-center justify-center rounded-lg bg-white focus:outline-none',
          value ? 'bg-gray-100' : 'hover:bg-gray-50'
        )}
        onClick={() => onChange(!value)}
      >
        {value ? <IconLetterCaseUpper size={16} /> : <IconLetterCase size={16} />}
      </button>
    }
    tooltipContent="Uppercase"
  />
));

SpeakerLabelUppercaseToggle.displayName = 'SpeakerLabelUppercaseToggle';

export default SpeakerLabelUppercaseToggle;
